export enum PortalTypeIdEnum {
  Internal = 1,
  Employer = 2,
  Member = 3
}
